<template>
  <PageHeader></PageHeader>

  <div class="page-wrapper">
    <div class="container">
      <div class="content">
        <!-- Blog Post Title -->
        <h1 class="post-title">{{ post.title }}</h1>

        <!-- Author and Date Info -->
        <div class="post-meta">
          <p>By {{ post.author }} - {{ post.date }}</p>
        </div>

        <!-- Blog Image -->
        <img :src="post.image" :alt="post.imageDescription" class="post-image">

	<div class="mp-container">
  <article v-if="renderedMarkdown" class="md-content">
    <div v-html="renderedMarkdown"></div>
  </article>
	</div>
	<!--

	<div class="md-content">
	  <article v-if="renderedMarkdown" class="md-content">
	          <component :is="renderedMarkdown" />

	  </article>
	</div>
-->


	
        <!-- Social Links -->
        <div class="social-links">
          <h3>Connect with me:</h3>
          <div class="icons">
            <a href="https://www.linkedin.com/in/jerschwartz/" target="_blank">
              <font-awesome-icon :icon="['fab', 'linkedin']" />
            </a>
            <a href="https://www.instagram.com/jbot/" target="_blank">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
          </div>
        </div>

        <!-- Back to Blog Listing Link -->
        <a href="/blog" class="back-link">← Back to Blog Listing</a>
      </div>
    </div>

    <footer class="footer">
      <p>Copyright howtojeremy.com© 2025 All rights reserved</p>
    </footer>
  </div>
</template>


<script>
import PageHeader from './PageHeader.vue';
import MarkdownIt from 'markdown-it';
import { shallowRef, onMounted, watch } from 'vue'
const md = new MarkdownIt();
const Comp = shallowRef(null)

export default {
  name: 'BlogPost',
  components: {
    PageHeader
  },
    props: {
	id: {
	type: String, // or Number, depending on your use case
	required: true
	}
    },    
    data() {
	return {
	    post: {},
	    renderedMarkdown: '' // We'll store the HTML here
	}
    
  },
    methods: {
	fetchPost() {
	    console.log(`/posts/${this.id}.json`)
	    fetch(`/posts/${this.id}.json`)
		.then(res => res.json())
		.then(data => {
		    this.post = data;
		    console.log("DATA")
		    // Now fetch the actual content
		    console.log(`/posts/${this.id}.md`);
		    //          return fetch(`/posts/${this.id}.md`);
		    fetch(`/posts/${this.id}.md`)
			.then(res => res.text())
			.then(markdownText => {

			    this.renderedMarkdown = md.render(markdownText);
			    console.log(this.renderedMarkdown)
			    })
			      
		})
	    /*
        .then(res => res.text())
        .then(markdownText => {
          // This is the "magic" step:
          this.renderedMarkdown = md.render(markdownText);
        })
        .catch(err => console.error("Fetch error:", err));
	*/
    }

    },
    mounted() {

	console.log("Mounted:",this.id)

	this.fetchPost();
			 
    }
}


</script>

<style scoped>
  .page-wrapper {
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.container {
  max-width: 90vw;
  margin: 0 auto;
}

.content {
  background-color: white;
  border-radius: 1rem;
  padding: 2.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.post-title {
  font-size: 2.25rem;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 1rem;
}

.post-meta {
  margin-bottom: 2rem;
  color: #6b7280;
  font-size: 0.875rem;
}

.post-image {
  width: 50%;
  max-width: 400px;
  object-fit: cover;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
}

.post-content {
  color: #374151;
  margin-bottom: 2rem;
  line-height: 1.75;
}

.social-links {
  margin-bottom: 2rem;
}

.social-links h3 {
  font-weight: bold;
  color: #111827;
  margin-bottom: 0.75rem;
}

.icons {
  display: flex;
  gap: 1.5rem;
}

.icons a {
  font-size: 1.5rem;
  color: inherit;
  transition: opacity 0.3s;
}

.icons a:hover {
  opacity: 0.7;
}

.icons a:nth-child(1) {
  color: #2563eb;
}

.icons a:nth-child(2) {
  color: #ec4899;
}

.back-link {
  color: #2563eb;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}

.footer {
  text-align: center;
  padding: 1.5rem;
  color: #6b7280;
  margin-top: 2rem;
}

.md-content {
  line-height: 1.6;
  color: #2c3e50;
  max-width: 800px;
  margin: 0 auto;

}

/* Target elements inside v-html using :deep() */

.md-content :deep(h1) {
  font-size: 2.5rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-weight: 700;
  border-bottom: 1px solid #eaecef;
  padding-bottom: 0.3rem;
}

.md-content :deep(h2) {
  font-size: 2rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
  border-bottom: 1px solid #eaecef;
  padding-bottom: 0.3rem;
}

.md-content :deep(h3) {
  font-size: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 0.8rem;
  font-weight: 600;
}

.md-content :deep(p) {
  margin-bottom: 1.2rem;
  font-size: 1.1rem;
}

/* Bonus: Styling for code snippets and lists */
.md-content :deep(code) {
  background-color: #f6f8fa;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-family: monospace;
  font-size: 90%;
}

.md-content :deep(ul), 
.md-content :deep(ol) {
  padding-left: 2rem;
  margin-bottom: 1.2rem;
}

.md-content :deep(li) {
  margin-bottom: 0.5rem;
}

.md-content :deep(blockquote) {
  margin: 1rem 0;
  padding: 0 1rem;
  color: #6a737d;
  border-left: 0.25rem solid #dfe2e5;
}



</style>

